/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_3a81462e"]'><div :class='["dialog-alert-passenger-demo"]'><cube-button @_click="onClickDialog">Dialog - alert</cube-button><cube-dialog ref="__mpx_ref_dialogAlert__" title="我是标题" content="正文行文符合话术规范，表意清晰可多行展示，单行居中对齐，多行居左" confirmBtn="引导文案"></cube-dialog></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_3a81462e"}'>
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_3a81462e"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_3a81462e"}
  /** script content **/
  require("./dialog-alert.mpx.js?isComponent&outputPath=components%2Fdialog-alert3a81462e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./dialog-alert.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdialog-alert3a81462e%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_3a81462e"],
    ctorType: "component",
    outputPath: "components/dialog-alert3a81462e/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-dialog':getComponent(require("../../../packages/mpx-cube-ui/src/components/dialog/index.mpx?isComponent&outputPath=components%2Findex8b435562%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>